<script>
    import Boton from "../../../../assets/src/Components/UI/Boton.svelte";

    export let valor = '';
    let verClave = false;
</script>

<div class="campo">
    <input type={verClave ? 'text' : 'password'} value={valor} on:input/>

    <div class="boton">
        <Boton on:click={() => verClave = !verClave} radio={false}
               icono={verClave ? 'visibility' : 'visibility_off' }>
            {#if verClave}
                Ocultar&nbsp;contraseña
            {:else}
                Mostrar&nbsp;contraseña
            {/if}
        </Boton>
    </div>
</div>

<style>
    .campo {
        display: grid;
        grid-template-columns: 1fr max-content;
    }

    input {
        grid-column: 1;
        grid-row: 1;
        font: inherit;
        height: 40px;
        margin: 0;
        border-radius: 0;
        border-right: 0;
    }

    .boton {
        grid-column: 2;
        grid-row: 1;
    }
</style>